import React, {useEffect} from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles';
import {Grid,Typography,Hidden} from '@material-ui/core';
import { theme } from '../../theme';
import axios from 'axios'
import ReactLoading from "react-loading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faYoutube } from "@fortawesome/free-brands-svg-icons"

const Monoacts = () => {
  const [loaded, setLoaded] = React.useState(true);
  const [ma, setMa] = React.useState([]);

  const handleYTLink = link => () => {
    window.open(link);
  };

  const socialIconStyle = {
    marginTop: 20,
    cursor: 'pointer',
    color:'red',
  };

  useEffect(() => {
    setLoaded(true)
    //all articles
    axios.get('https://djaura.pythonanywhere.com/ma/').then(res => {
      let items = res.data;
      let newState = [];
      for (let item in items) {
        newState.push({
          id: item,
          description: items[item].ma_desc,
          title: items[item].ma_topic,
          date: items[item].ma_acad_year,
          image: items[item].ma_img,
          link:items[item].ma_link
        });
      }
      setMa(newState)
      setLoaded(false)
    });
  }, [])

  return (
    <MuiThemeProvider theme={theme}>
    <Typography variant="h6" className="work-description fadeInUp" style={{ animationDelay: '0.58s' }}>
   <i>“Without wonder and insight, acting is just a business. With it, it becomes creation.”</i>
   </Typography>
   <Grid container  className="fadeInUp" style={{ animationDelay: '0.7s' }}>
        {loaded ? <ReactLoading type={"bars"} color={"white"} className="loading" /> :

          ma.map((elm, index) => {
            if(index%2===0){

              return (
                <Grid key={index} id="content" className="content-wrapper extra-padding" item xs={12} md={12}>
                  <Grid container className="fadeInUp" style={{ animationDelay: '0.72s' }}>
                    <Hidden only={['lg', 'xl', 'md']}>
                      <Grid item xs={12} sm={12} >
                        <p className="title-sm">
                          {index + 1} &nbsp; {elm.title}
                        </p>
                      </Grid>
                    </Hidden>
                    <Grid item xs={12} sm={10} md={4} style={{ alignSelf: 'center' }} id="image-grid">
                      <div className="img-outer-wrapper">
                        <img alt={elm.title} src={elm.image}  className="streetplay-image" />
                      </div>
                    </Grid>
                    <Grid item xs={12} md={8}>
                      <Hidden only={['sm', 'xs']}>
                        <p className="title">
                          {index + 1} &nbsp; {elm.title}  &#9679; {elm.date}
                        </p>
                      </Hidden>
                      <Typography variant="h6" className="streetplay-description">
                        {elm.description}
                      </Typography>
                      <Typography onClick={handleYTLink(elm.link)} variant="h6" style={{cursor: 'pointer',fontSize:'1.3rem',textAlign:'left',marginTop:10,paddingLeft:'4%',color:'white'}}>
                        CHECK IT OUT ON <   FontAwesomeIcon className="icon"
                          style={socialIconStyle}
                          icon={faYoutube}
                          ></FontAwesomeIcon>
                          </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              )
              }
              else{
                return (
                  <Grid key={index} id="content" className="content-wrapper extra-padding" item xs={12} md={12}>
                    <Grid container className="fadeInUp" style={{ animationDelay: '0.72s' }}>
                      <Hidden only={['lg', 'xl', 'md']}>
                        <Grid item xs={12} sm={12} >
                          <p className="title-sm">
                            {index + 1} &nbsp; {elm.title}
                          </p>
                        </Grid>
                      </Hidden>
                      <Hidden only={['sm', 'xs']}>
                      <Grid item xs={12} md={8}>
                      <p className="title">
                            {index + 1} &nbsp; {elm.title}  &#9679; {elm.date}
                          </p>
                      <Typography variant="h6" className="streetplay-description">
                          {elm.description}
                        </Typography>
                        <Typography onClick={handleYTLink(elm.link)} variant="h6" style={{cursor: 'pointer',fontSize:'1.3rem',textAlign:'left',marginTop:10,paddingLeft:'4%',color:'white'}}>
                        CHECK IT OUT ON <   FontAwesomeIcon className="icon"
                          style={socialIconStyle}
                          icon={faYoutube}
                          ></FontAwesomeIcon>
                          </Typography>
                        </Grid>
                        </Hidden>
                      <Grid item xs={12} sm={10} md={4} style={{ alignSelf: 'center' }} id="image-grid">
                        <div className="img-outer-wrapper">
                          <img alt={elm.title} src={elm.image} className="streetplay-image" />
                        </div>
                      </Grid>
                        <Hidden only={['lg', 'xl', 'md']}>
                        <Grid item xs={12} md={8}>
                        <Typography variant="h6" className="streetplay-description">
                          {elm.description}
                        </Typography>
                        <Typography onClick={handleYTLink(elm.link)} variant="h6" style={{cursor: 'pointer',fontSize:'1.3rem',textAlign:'left',marginTop:10,paddingLeft:'4%',color:'white'}}>
                        CHECK IT OUT ON <   FontAwesomeIcon className="icon"
                          style={socialIconStyle}
                          icon={faYoutube}
                          ></FontAwesomeIcon>
                          </Typography>
                        </Grid>
                        </Hidden>
                    </Grid>
                  </Grid>
                )
              }
          })
        }

      </Grid>
</MuiThemeProvider>
  );
};

export default Monoacts;
